

export type BookTypes = 'O' | 'C';

export enum BOOK_TYPES {
    OPERACIONES = 'O',
    COBRANZAS = 'C',
}